import { render, staticRenderFns } from "./BasketballStats.vue?vue&type=template&id=2191300d&scoped=true&"
import script from "./BasketballStats.vue?vue&type=script&lang=js&"
export * from "./BasketballStats.vue?vue&type=script&lang=js&"
import style0 from "./BasketballStats.vue?vue&type=style&index=0&id=2191300d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2191300d",
  null
  
)

export default component.exports